module.exports = __webpack_public_path__ + "img/0.f41ed4e1.png";